import SurveyResponsesNpsScoreCard from './SurveyResponsesNpsScoreCard';

export default SurveyResponsesNpsScoreCard;
